import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { addressFormSlice } from "./AddressManager/reducers/addressFormReducer";
import { addressListSlice } from "./AddressManager/reducers/addressListReducer";
import { contactDetailSlice } from "./ContactManager/reducers/contactDetailReducer";
import { contactListSlice } from "./ContactManager/reducers/contactListReducer";
import { userAccountAssignmentsSlice } from "./ContactManager/reducers/userAccountAssignmentsReducer";
import { addAssignmentsToUserSlice } from "./ContactManager/reducers/addAssignmentsToUserReducer";
import { contactNoteManagerSlice } from "./ContactNoteManager/reducers/contactNoteManagerReducer";
import { enumFormSlice } from "./EnumManager/reducers/enumFormReducer";
import { enumManagerSlice } from "./EnumManager/reducers/enumManagerReducer";
import { addChildOrganizationsSlice } from "./OrganizationManager/reducers/addChildOrganizationsReducer";
import { addContactsToOrganizationSlice } from "./OrganizationManager/reducers/addContactsToOrganizationReducer";
import { childOrganizationListSlice } from "./OrganizationManager/reducers/childOrganizationListReducer";
import { contactListInOrganizationSlice } from "./OrganizationManager/reducers/contactListInOrganizationReducer";
import { organizationDetailSlice } from "./OrganizationManager/reducers/organizationDetailReducer";
import { organizationListSlice } from "./OrganizationManager/reducers/organizationListReducer";
import { adminInfoSlice } from "./AdminInfo/adminInfoReducer";


const reducer = combineReducers({
    contactList: contactListSlice.reducer,
    contactDetail: contactDetailSlice.reducer,
    contactNoteManager: contactNoteManagerSlice.reducer,
    enumManager: enumManagerSlice.reducer,
    enumForm: enumFormSlice.reducer,
    addressList: addressListSlice.reducer,
    addressForm: addressFormSlice.reducer,
    organizationList: organizationListSlice.reducer,
    organizationDetail: organizationDetailSlice.reducer,
    childOrganizationList: childOrganizationListSlice.reducer,
    addChildOrganizations: addChildOrganizationsSlice.reducer,
    addContactsToOrganization: addContactsToOrganizationSlice.reducer,
    contactListInOrganization: contactListInOrganizationSlice.reducer,
    userAccountAssignments: userAccountAssignmentsSlice.reducer,
    addAssignmentsToUser: addAssignmentsToUserSlice.reducer,
    adminInfo: adminInfoSlice.reducer,
});

const store = (readOnly: boolean) => {
    var store = configureStore({
        reducer,
        preloadedState: {
            adminInfo: {
                readOnly
            }
        }
    });
    return store;
};

export type AppDispatch = ReturnType<typeof store>["dispatch"];
export type RootState = ReturnType<typeof reducer>;
export default store;
